import { create } from "zustand";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface ErrorState {
  open: boolean;
  message: any;
  showError: (msg: any) => void;
  closeError: () => void;
}

const useErrorStore = create<ErrorState>((set) => ({
  open: false,
  message: null,
  showError: (msg) => set({ open: true, message: msg }),
  closeError: () => set({ open: false, message: null }),
}));

export default useErrorStore;
